import { getUrl, Post, Get, Put, Patch } from '.'

export const List = async body => {
  return Post(getUrl('cnps.css.store.search'), body)
}

export const ListAll = async body => {
  return Post(getUrl('cnps.css.store.search-all'), body)
}

export const Detail = async id => {
  return Get(getUrl('cnps.css.store.get', { id }))
}

export const Update = async (id, body) => {
  return Put(getUrl('cnps.css.store.update', { id }), body)
}

export const Create = async body => {
  return Post(getUrl('cnps.css.store.create'), body)
}

export const GetHistoryRenameStore = async body => {
  return Post(getUrl('cnps.css.store.list-change-history'), body)
}
